import PropTypes from 'prop-types'
import React from 'react'

import CopyEmail from './CopyEmail'
import MemberCallout from './MemberCallout'
import MemberEmailButton  from './MemberEmailButton'
import {ordinalify} from './util'

import './WardDetail.css'

const WardDetail = ({member, onClose, emailSubjectTpl, emailBodyTpl}) => {
  if (!member) {
    return false
  }

  const wardName = `${ordinalify(member.ward)} Ward`
  // TODO: Pass this template through the ArciheML
  const aldermanText = `${member.name} is the alderperson for the ${wardName}.`

  let emailButton = null
  let copyEmail = null
  if (emailSubjectTpl && emailBodyTpl) {
    emailButton = (<div className="WardDetail-button-container"><MemberEmailButton member={member} emailSubjectTpl={emailSubjectTpl} emailBodyTpl={emailBodyTpl} /></div>)
    copyEmail = <CopyEmail member={member} emailBodyTpl={emailBodyTpl} />
  }

  return (
    <div className="WardDetail">
      <h2 className="WardDetail-title">{wardName}</h2>
      <p>{aldermanText}</p>
      {emailButton}
      {copyEmail}
      <MemberCallout member={member} />
      <button className="WardDetail-close" onClick={onClose}>✖</button>
    </div>
  )
}

WardDetail.propTypes = {
  member: PropTypes.object,
  onClose: PropTypes.func,
  emailSubjectTpl: PropTypes.func,
  emailBodyTpl: PropTypes.func
}

export default WardDetail



// WEBPACK FOOTER //
// ./src/WardDetail.js